/* ============================================================================
   cgv-consent.js — v2.2 (13/09/2026)
   Parfumerie du Soleil d'Or
   ----------------------------------------------------------------------------
   v2.1 et v2.2 — 13/09/2026 : l'attribut porte désormais le DÉTAIL DOUANIER
   réellement affiché (pays, estimation, valeur du panier) au lieu du libellé
   générique « Droits et taxes acceptés (hors UE) », et il est resynchronisé
   dès que ce détail change. Voir les commentaires de dapDetail(), seed() et
   resync() plus bas.

   CE QUI CHANGE PAR RAPPORT À LA v1

   1. ÉCRITURE SERVEUR AU CLIC SUR LA CASE
      L'attribut est poussé dans le panier par /cart/update.js dès que la case
      change, et plus seulement au moment de la soumission du formulaire.
      C'est le seul moyen que la trace survive à un checkout accéléré :
      Apple Pay, PayPal et Shop Pay ne soumettent jamais #cart ni
      #CartDrawer-Form, ils partent du panier serveur tel quel.
      Le champ caché name="attributes[...]" est conservé en repli si le fetch
      échoue (réseau, JS bloqué en cours de route).

      L'URL passe par Shopify.routes.root : /cart/update.js en dur casserait
      sur les marchés anglophones servis sous /en/.

   2. ÉTAT UNIQUE, PLUS PAR FORMULAIRE
      Il y a un seul panier, donc un seul attribut. La v1 gardait accepted
      par formId : cocher dans le tiroir puis ouvrir /cart redemandait de
      cocher. L'état est désormais commun, et amorcé au chargement depuis
      data-cgv-accepted, écrit côté Liquid depuis cart.attributes.

   3. VOILE SUR LES EXPRESS — RECHERCHE CORRIGÉE
      La v1 faisait closest('.cart__submit-controls, .cart__ctas,
      .cart__buttons-container'), qui s'arrête au PREMIER ancêtre, soit
      .cart__submit-controls. Or le conteneur express de cart-template.liquid
      est en dehors de .cart__submit-controls : le voile n'a jamais été posé.
      On borne désormais la recherche à la région du panier concerné
      (cart-drawer ou #main-cart-footer), ce qui évite aussi que le bloc du
      tiroir ne verrouille les express de la page panier, les deux DOM
      coexistant sur /cart.

   4. LE GARDE-CLIC N'EST PLUS LA DÉFENSE PRINCIPALE
      PayPal, Shop Pay et Apple Pay sont rendus dans des iframes : un clic
      dedans ne produit aucun événement dans le document parent. Seul
      pointer-events: none sur le conteneur parent bloque réellement, d'où la
      classe .cgv-express-locked. Le garde-clic reste, il ne couvre que les
      boutons express éventuellement rendus hors iframe.

   CSS REQUIS (component-cart.css) — sans lui, rien ne bloque :
     .cgv-express-locked { pointer-events: none; opacity: .45; filter: grayscale(1); }

   RESTE NON COUVERT : le bouton de paiement dynamique de la FICHE PRODUIT,
   qui court-circuite le panier entièrement. Décision commerciale à part.
   ========================================================================= */

(function () {
  if (window.__cgvConsentInit) return;
  window.__cgvConsentInit = true;

  var ATTR = 'Acceptation CGV et expédition';
  var GUARDED = { cart: 1, 'CartDrawer-Form': 1 };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Valeur d'acceptation courante, commune aux deux paniers.
     null = non accepté. */
  var value = null;

  function pad(n) { return String(n).padStart(2, '0'); }

  function isoNow() {
    var d = new Date(), o = -d.getTimezoneOffset(), s = o >= 0 ? '+' : '-';
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' +
      pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()) +
      s + pad(Math.floor(Math.abs(o) / 60)) + ':' + pad(Math.abs(o) % 60);
  }

  function allBlocks() { return document.querySelectorAll('[data-cgv-consent]'); }
  function blockFor(formId) {
    return document.querySelector('[data-cgv-consent][data-cgv-form="' + formId + '"]');
  }

  /* Région du panier auquel appartient un bloc : le tiroir ou le pied de la
     page panier. Borne la recherche du conteneur express. */
  function regionOf(block) {
    return block.closest('cart-drawer, #main-cart-footer, .cart-page-section') || block.parentElement;
  }

  function gateOf(block) {
    var r = regionOf(block);
    return r ? r.querySelector('.additional-checkout-buttons, .cgv-express-gate') : null;
  }

  /* Pousse (ou efface) l'attribut dans le panier serveur. Silencieux en cas
     d'échec : le champ caché du formulaire reste le repli. */
  var inflight = null;
  function push(v) {
    var body = { attributes: {} };
    body.attributes[ATTR] = v || '';
    inflight = fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { /* repli : champ caché */ });
    return inflight;
  }

  function apply(block) {
    if (!block) return;
    var box = block.querySelector('.cgv-consent__box');
    var hidden = block.querySelector('.cgv-consent__value');
    var err = block.querySelector('.cgv-consent__error');
    if (!box || !hidden) return;

    if (value) {
      box.checked = true;
      hidden.value = value;
      if (err) err.classList.add('hide');
    } else {
      box.checked = false;
      hidden.value = '';
    }

    var gate = gateOf(block);
    if (gate) {
      gate.classList.toggle('cgv-express-locked', !value);
      gate.setAttribute('aria-disabled', value ? 'false' : 'true');
    }
  }

  function applyAll() { Array.prototype.forEach.call(allBlocks(), apply); }

  /* Détail douanier RÉELLEMENT AFFICHÉ au moment du clic — v2.1, 13/09/2026.
     Remplace le libellé générique « Droits et taxes acceptés (hors UE) », qui
     attestait du consentement mais pas de CE QUE le client avait sous les yeux.
     Or c'est le montant qui est contesté après livraison.
     La chaîne est composée par sdo-douanes-panier.liquid et exposée sur
     [data-sdo-cgv-detail] : pays, estimation affichée, valeur du panier.
     Deux blocs coexistent sur /cart (tiroir + page) : on lit celui de la même
     région que la case cochée, sinon le premier trouvé. */
  function dapDetail(block) {
    if (block.getAttribute('data-cgv-dap') !== '1') return '';
    var region = regionOf(block);
    var span = (region && region.querySelector('[data-sdo-cgv-detail]'))
      || document.querySelector('[data-sdo-cgv-detail]');
    var detail = span ? (span.getAttribute('data-sdo-cgv-detail') || '').trim() : '';
    return detail ? ' | ' + detail : ' | Droits et taxes acceptés (hors UE)';
  }

  function onToggle(box) {
    var block = box.closest('[data-cgv-consent]');
    if (!block) return;
    if (box.checked) {
      value = 'Oui' + dapDetail(block) + ' | ' + (block.getAttribute('data-cgv-version') || '') + ' | ' + isoNow();
    } else {
      value = null;
    }
    applyAll();
    push(value);
  }

  function blocked(formId) { return GUARDED[formId] && blockFor(formId) && !value; }

  function showError(formId) {
    var block = blockFor(formId);
    if (!block) return;
    var err = block.querySelector('.cgv-consent__error');
    if (err) err.classList.remove('hide');
    var box = block.querySelector('.cgv-consent__box');
    if (box) box.focus();
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('cgv-consent__box')) {
      onToggle(e.target);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* Checkout classique. */
    var btn = e.target.closest('#checkout, #CartDrawer-Checkout');
    if (btn) {
      var formId = btn.getAttribute('form') || (btn.form && btn.form.id);
      if (blocked(formId)) { e.preventDefault(); e.stopImmediatePropagation(); showError(formId); }
      return;
    }

    /* Express rendus hors iframe. Ceux en iframe sont bloqués par le CSS. */
    var gate = e.target.closest('.additional-checkout-buttons, .cgv-express-gate');
    if (gate) {
      var region = gate.closest('cart-drawer, #main-cart-footer, .cart-page-section');
      var block = region ? region.querySelector('[data-cgv-consent]') : null;
      var fid = block ? block.getAttribute('data-cgv-form') : null;
      if (fid && blocked(fid)) { e.preventDefault(); e.stopImmediatePropagation(); showError(fid); }
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && GUARDED[f.id] && blocked(f.id)) {
      e.preventDefault(); e.stopImmediatePropagation(); showError(f.id);
    }
  }, true);

  /* Amorçage : valeur déjà présente dans le panier, écrite côté Liquid.
     v2.1 — 13/09/2026 : si le détail douanier a changé depuis, la valeur est
     RECOMPOSÉE et repoussée. Constaté sur la commande #50336, validée le
     13/09 avec un attribut horodaté au 26/08 : le client avait coché deux
     semaines plus tôt, et ni le montant ni la date n'avaient suivi le panier.
     Une estimation périmée est pire que pas d'estimation. */
  (function seed() {
    var b = document.querySelector('[data-cgv-consent][data-cgv-accepted]');
    var v = b ? (b.getAttribute('data-cgv-accepted') || '').trim() : '';
    if (!v) return;
    value = v;

    var attendu = 'Oui' + dapDetail(b) + ' | ' + (b.getAttribute('data-cgv-version') || '');
    if (v.indexOf(attendu) !== 0) {
      value = attendu + ' | ' + isoNow();
      push(value);
    }
  })();

  /* Resynchronisation du détail douanier — v2.2, 13/09/2026.
     seed() ne s'exécute qu'au chargement : un client qui ajoute un article
     depuis le tiroir, sans recharger la page, gardait un attribut figé sur
     l'ancien panier. Constaté sur une commande de 478 $ dont l'attribut
     annonçait 336 $ et une estimation de 85,40 $ au lieu de 106,70 $.
     La valeur est désormais recomposée dès que le montant affiché change. */
  function resync() {
    if (!value) return;
    var b = document.querySelector('[data-cgv-consent]');
    if (!b) return;
    var attendu = 'Oui' + dapDetail(b) + ' | ' + (b.getAttribute('data-cgv-version') || '');
    if (value.indexOf(attendu) !== 0) {
      value = attendu + ' | ' + isoNow();
      applyAll();
      push(value);
    }
  }

  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyAll(); resync(); });
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  applyAll();
})();